import utils from './utils';

async function handleSubmit(event) {
    const form = event.target;
    const username = form.querySelector('input[name="log"]');
    const password = form.querySelector('input[name="pwd"]');
    if (username && !username.value) {
        utils.setFieldError({input: username, message: 'This field is required.'});
        event.preventDefault();
    }
    if (password && !password.value) {
        utils.setFieldError({input: password, message: 'This field is required.'});
        event.preventDefault();
    }
}

function close() {
    const referrer = new URL(document.referrer);
    if (referrer.href === window.location.href || referrer.host !== window.location.host) {
        window.location.href = '/';
    }
    window.location.href = referrer.href;
}

export default function () {
    document.querySelectorAll('.payments-login-form').forEach((element) => {
        element.addEventListener('submit', handleSubmit);
    });
    document.querySelectorAll('.payments-login-close').forEach((element) => {
        element.addEventListener('click', close);
    });
}